export class OriginDestinationMatrixType {
}
OriginDestinationMatrixType.Manual = 0;
OriginDestinationMatrixType.OneToManyRandom = 1;
OriginDestinationMatrixType.TripLayerData = 2;
